import PropTypes from 'prop-types';
import React from 'react';

var ChartRectClipPath = function ChartRectClipPath(_ref) {
  var id = _ref.id,
      x = _ref.x,
      y = _ref.y,
      width = _ref.width,
      height = _ref.height;
  return React.createElement("clipPath", {
    id: id
  }, React.createElement("rect", {
    x: x,
    y: y,
    width: width,
    height: height
  }));
};

ChartRectClipPath.displayName = 'ChartRectClipPath';
ChartRectClipPath.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  id: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired
};
ChartRectClipPath.defaultProps = {
  x: 0,
  y: 0
};
export default ChartRectClipPath;